import * as React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line no-restricted-imports -- Root level import allowed
import { Toast } from '@opendoor/bricks/complex/Toast';
import { Themed } from '@opendoor/bricks/theme/ODTheme';
import faviconPath from '@opendoor/shared-fe/build/faviconPath';

import Routes from './routes';

export default class App extends React.Component {
  public render(): JSX.Element {
    return (
      <div>
        <Helmet>
          <title>Opendoor</title>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
          <meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=no" />
          <meta name="fragment" content="!" />
          <meta httpEquiv="Accept-CH" content="DPR, Width, Viewport-Width" />
          <link rel="shortcut icon" href={faviconPath()} type="image/png" />
          <link
            rel="apple-touch-icon"
            sizes="144x144"
            href="https://www.opendoor.com/apple-touch-icon-144.png"
          />
        </Helmet>
        <Themed theme="legacy">
          <Routes />
          {/* Toast should only be mounted once at the root */}
          <Toast />
        </Themed>
      </div>
    );
  }
}
